export default {
  hero: {
    breadcrumbs: {
      home: 'Home',
      properties: 'Properties'
    }
  },
  property: {
    title: 'Title',
    description: 'Description',
    price: 'Price',
    price_currency: 'Currency',
    gross_area: 'Total area',
    net_area: 'Living area',
    floor: 'Floor',
    total_floors: 'Total floors',
    rooms: 'Number of rooms',
    layout_type: 'Layout type',
    status: 'Property status',
    purpose: 'Purpose',
    ownership: 'Ownership',
    heating: 'Heating type',
    orientation: 'Orientation',
    view: 'View',
    address: 'Address',
    year_of_construction: 'Year of construction',
    location: 'Location',
    video: 'Video overview',
    features: 'Features',
    contact_agent: 'Contact agent',
    request_price: 'Request current price',
    back_to_all: '← Back to all properties',
    developer: 'Developer',
    residential_complex: 'Residential complex',
    building: 'Building',
    ai_prediction: 'AI Valuation',
    evaluation_chart: 'Valuation chart',
    map: 'Map',
    gallery: 'Gallery',
    video_tour: 'Video tour',
    loading: 'Loading property data...',
    catalog_id: 'Catalog number',
    layout_type_label: 'Object type',
    status_label: 'Status',
    purpose_label: 'Purpose',
    heating_label: 'Heating',
    orientation_label: 'Orientation',
    building_type_label: 'Building type',
    view_label: 'View',
    citizenship_available: 'Eligible for citizenship',
    mortgage_available: 'Mortgage available',
    not_specified: 'Not specified',

    // From PropertyCharacteristics
    country: 'Country',
    region: 'Region',
    city: 'City',
    district: 'District',
    residential_complex_label: 'Residential complex',
    building_label: 'Building',
    rooms_label: 'Number of rooms',
    floor_label: 'Floor',
    total_floors_label: 'Total floors',
    gross_area_label: 'Total area',
    net_area_label: 'Living area',
    year_of_construction_label: 'Year built',
    heating_label_fallback: 'Heating',
    orientation_label_fallback: 'Orientation',
    building_type_label_fallback: 'Building type',
    view_label_fallback: 'View',

    gallery_title: 'Property photos',

    agent: {
      full_name: 'Agent',
      agency: 'Agency',
      phone: 'Phone'
    },

    amenities: {
      title: 'Amenities',
      empty: 'No amenities specified'
    },

    characteristics: {
      title: 'Characteristics',
      loading: 'Loading characteristics...'
    },

    video: {
      no_video: 'No video available'
    },

    unpublished: {
      title: '🏗️ Property not published',
      message: 'This property is not available for public viewing.',
      location: 'Location',
      home: 'Back to homepage'
    }
  }
}
